export default {"src":"/_next/static/media/1on1_pc_img_sub_01.cbb49496.svg","height":350,"width":920};